import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from '../services/translation.service';
import { PermissionsService } from '../services/permissions.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-top-menu',
  templateUrl: 'top-menu.component.html'
})
export class TopMenuComponent {
  public translations: any = {};
  public permissions = [];
  public orgType: string;

  constructor(
    private translationService: TranslationService,
    private permissionService: PermissionsService,
    private authService: AuthService
  ) {
    this.translations = translationService.getTranslations();
    this.permissions = this.permissionService.getPermissions();
    this.orgType = this.authService.getOrganisationType();
  }
}
